import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import Stack from '@mui/material/Stack';

export const PageLoader = () => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100vh">
      <Fade
        in={true}
        style={{
          transitionDelay: '700ms',
        }}
      >
        <CircularProgress size={64} color="primary" aria-label="Page loading indicator" />
      </Fade>
    </Stack>
  );
};
